import angular from "angular";
import { configureStates } from "../../../core/router/router-helper.provider";

const routes = [{
    state: "payroll.payStub",
    config: {
        // PayStub links redirect to gross pay history.
        url: "/paystub?{employeeID:int}&{payrollID:int}",
        component: "apexPayStubContainer",
        dynamic: true,
        resolve: {
            employeeId: ($transition$, employeeService) => {
                'ngInject';
                const params = $transition$.params();
                if (params.employeeID) {
                    return Number(params.employeeID);
                }
                return employeeService.retrieveIdentity()
                    .then(identity => identity.EmployeeID);
            },
            payrollId: $transition$ => {
                'ngInject';
                const params = $transition$.params();
                if (params.payrollID) {
                    return Number(params.payrollID);
                }
                return null;
            },
            isPayStub: () => false
        },
        data: {
            pageHeader: "Pay Stub Statement"
        }
    }
}, {
    state: "payroll.grossPayHistory",
    config: {
        url: "/grosspayhistory?{employeeID:int}&{payrollID:int}",
        component: "apexPayStubContainer",
        dynamic: true,
        resolve: {
            employeeId: ($transition$, employeeService) => {
                'ngInject';
                const params = $transition$.params();
                if (params.employeeID) {
                    return Number(params.employeeID);
                }
                return employeeService.retrieveIdentity()
                    .then(identity => identity.EmployeeID);
            },
            payrollId: $transition$ => {
                'ngInject';
                const params = $transition$.params();
                if (params.payrollID) {
                    return Number(params.payrollID);
                }
                return null;
            },
            isPayStub: () => false
        },
        data: {
            pageHeader: "Gross Pay Statement",
            permissionKey: "navigation:grossPayStatement"
        }
    }
}, {
    state: "payroll.grossPayHistory.id",
    config: {
        // Legacy route. The pay period ID is ignored.
        url: "/:id",
        redirectTo: "payroll.grossPayHistory"
    }
},
{
    state: "payroll.payStub.id",
    config: {
        // Legacy route. The pay period ID is ignored.
        url: "/:id",
        redirectTo: "payroll.grossPayHistory"
    }
}]

export const PayStubRoutingModule = angular
    .module("apex.mainApp.payroll.payStub.routing", [])
    .run(configureStates(routes))
    .name;
